export type Icon = string | { foreground: string, background: string, text: string }

export type OS = { name: string, icon?: Icon }

export const OSs : Record<string, OS> = {
    'windows': { name: 'Windows', icon: 'windows.svg' },
    'linux': { name: 'Linux', icon: 'linux.svg' },
    'macos': { name: 'macOS', icon: 'macos.svg' }
}

export type License = {
    name: string
}

export const Licenses : Record<string, License> = {
    nu: { name: 'Named User' },
    su: { name: 'Single Use'},
    uu: { name: 'Unlimited Use' },
    fu: { name: 'Floating Use' },
    cs: { name: 'Compute Server' },
    fcs: { name: 'Floating Compute Server' },
    wlssu: { name: 'WLS Single Use' },
    wlsuu: { name: 'WLS Unlimited Use' },
    wlscs: { name: 'WLS Compute Server' },
    ic: { name: 'Instant Cloud' },
    isv: { name: 'ISV' }
}

export type Framework = {
    name: string
    icon?: Icon
}

export type PackageManager = {
    name: string
    icon?: Icon
}

export type API = {
    name: string
    icon?: Icon
    defaultFrameworkName?: string
    frameworks?: Record<string, Framework>
    packageManagers?: Record<string, PackageManager>
}

export const APIs : Record<string, API> = {
    'python': {
        name: 'Python',
        icon: 'python.svg',
        defaultFrameworkName: 'Gurobipy',
        frameworks: {
            'pyomo': { name: 'Pyomo', icon: { background: '#E64A19', foreground: 'white', text: 'Pyomo' } },
            'pulp': { name: 'PuLP', icon: { background: '#FFC400', foreground: 'black', text: 'PuLP' } },
            'ortools': { name: 'OR-Tools', icon: { background: '#2E7D32', foreground: 'white', text: 'OR-Tools' }, },
            'cvxpy': { name: 'CVXPY', icon: { background: '#BBBBBB', foreground: 'black', text: 'CVXPY' }}
        },
        packageManagers: {
            'pip': { name: 'PIP', icon: 'pip.svg'},
            'anaconda': { name: 'Anaconda', icon: { background: '#2E7D32', foreground: 'white', text: 'Anaconda' } }
        }
    },
    'java': { name: 'Java', icon: { foreground: 'white', background: '#1976D2', text: 'Java' } },
    'csharp': {
        name: 'C#',
        icon: 'cs.png',
        packageManagers: {
            'nuget': { name: 'NuGet', icon: 'nuget.svg' }
        }
    },
    'cpp': { name: 'C++', icon: 'cpp.svg' },
    'c': { name: 'C', icon: 'c.png' },
    'r': { name: 'R', icon: 'r.svg' },
    'matlab': { name: 'MATLAB', icon: 'matlab.png' },
}

export type Platform = {
    name: string
}
export const Platforms : Record<string, Platform> = {
    'local': { name: 'Local' },
    'gcp': { name: 'Google Cloud Platform' },
    'aws': { name: 'Amazon Web Services' },
    'azure': { name: 'Microsoft Azure' }
}

export type Scenario = {
    api: string,
    framework: string,
    os: string,
    license: string,
    clusterManager: boolean,
    packageManager: string,
    platform: string
    containerServer: boolean,
    containerClient: boolean,
    containerOrchestration: boolean
}

export const DefaultScenario: Scenario = {
    api: 'python',
    os: 'windows',
    license: 'wlscs',
    framework: '',
    clusterManager: true,
    packageManager: 'pip',
    platform: 'local',
    containerClient: false,
    containerServer: false,
    containerOrchestration: false
}